import {
  Box,
  makeStyles,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { colors, moneyFormat } from 'design-system';
import getMonthlyPrice from 'src/functions/getMonthlyPrice';

const { formatMoney } = moneyFormat;

const useStyles = makeStyles(() => {
  const nullBorder = 'none 0px transparent';
  return {
    container: {
      display: 'flex',
      alignItems: 'flex-start',
    },
    informationText: {
      fontSize: 15,
      fontWeight: 400,
      lineHeight: 24,
    },
    divider: {
      width: '100%',
      paddingInline: '16px',
      borderTop: 'dashed 1px #0D2E68',
      borderBottom: nullBorder,
      borderLeft: nullBorder,
      borderRight: nullBorder,
    },
    loading: {
      color: colors.bright_turquoise,
    },
    cardPrice: ({ isMobile }: { isMobile: boolean }) =>
      isMobile
        ? { gap: '1rem', justifyContent: 'space-between' }
        : { flexDirection: 'column', justifyContent: 'center' },

    textQuotes: ({ isMobile }: { isMobile: boolean }) =>
      isMobile
        ? { fontSize: 12, fontWeight: 400 }
        : { fontSize: 15, fontWeight: 700 },
    cardPriceAnual: ({ isMobile }: { isMobile: boolean }) =>
      isMobile
        ? { flexDirection: 'column-reverse', alignItems: 'flex-end' }
        : {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
          },
    textQuotesAnual: ({ isMobile }: { isMobile: boolean }) =>
      isMobile
        ? { fontSize: 12, fontWeight: 400 }
        : { marginRight: '4px', fontSize: 15, fontWeight: 500 },
  };
});

type AmountSectionProps = {
  anualPrice: number;
  moneyType: string;
};

export const AmountSection = ({
  anualPrice,
  moneyType,
}: AmountSectionProps): JSX.Element => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const classes = useStyles({ isMobile });

  return (
    <Box display="flex" width="100%" className={classes.cardPrice}>
      <Box
        display="flex"
        flexDirection="column"
        style={
          isMobile ? { alignItems: 'flex-start' } : { alignItems: 'center' }
        }
      >
        <Typography
          variant="h2"
          style={isMobile ? { fontSize: 23 } : { fontSize: 27 }}
        >
          {formatMoney(getMonthlyPrice(anualPrice), true, moneyType)}
        </Typography>
        <Typography variant="caption" className={classes.textQuotes}>
          12 cuotas mensuales
        </Typography>
      </Box>
      {!isMobile && <hr className={classes.divider} />}
      <Box display="flex" className={classes.cardPriceAnual}>
        <Typography variant="caption" className={classes.textQuotesAnual}>
          Total anual{!isMobile && ':'}
        </Typography>
        <Typography
          variant="h2"
          style={
            isMobile ? { fontSize: 23 } : { fontSize: 19, fontWeight: 700 }
          }
        >
          {formatMoney(anualPrice, true, moneyType)}
        </Typography>
      </Box>
    </Box>
  );
};

export default AmountSection;
